import type { BadgeProps } from '@nuxt/ui'
import type { HealthState } from '@/types'
import { formatDistanceToNow } from 'date-fns'

interface HealthPresentation {
  label: string
  color: BadgeProps['color']
  icon: string
  /** Hex/CSS colour for charts, aligned with the badge colour. */
  chartColor: string
}

const PRESENTATION: Record<HealthState, HealthPresentation> = {
  ok: { label: 'Healthy', color: 'success', icon: 'i-lucide-circle-check', chartColor: 'var(--ui-success)' },
  degraded: { label: 'Degraded', color: 'warning', icon: 'i-lucide-triangle-alert', chartColor: 'var(--ui-warning)' },
  down: { label: 'Down', color: 'error', icon: 'i-lucide-circle-x', chartColor: 'var(--ui-error)' },
  never_reported: { label: 'Never reported', color: 'neutral', icon: 'i-lucide-circle-help', chartColor: 'var(--ui-border-accented)' },
}

export function healthPresentation(state: HealthState): HealthPresentation {
  return PRESENTATION[state] ?? PRESENTATION.never_reported
}

export function formatRelative(value: string | null): string {
  return value ? formatDistanceToNow(new Date(value), { addSuffix: true }) : 'never'
}
